//@flow
import * as Immutable from 'immutable';

import {
    Checklist,
    TaskChecklists,
    SelectedChecklist,
    SelectedChecklists
} from 'common/models/flow/TaskChecklists';
import type {
    ChecklistModelType,
    TaskChecklistsModelType,
    SelectedChecklistModelType,
    SelectedChecklistsModelType
} from 'common/models/flow/TaskChecklists';

import { ChecklistItem, SelectedChecklistItem } from './ChecklistItem';

class InternalChecklist extends Checklist {
    static fromJS(json: ChecklistModelType): InternalChecklist {
        const state: Object = Object.assign({}, json);
        state.items = Immutable.List(state.items).map(item =>
            ChecklistItem.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    get items(): Immutable.List<ChecklistItem> {
        return this._state.get('items');
    }
}

class InternalTaskChecklists extends TaskChecklists {
    static fromJS(json: TaskChecklistsModelType): InternalTaskChecklists {
        const state: Object = Object.assign({}, json);
        state.cancelled = state.cancelled
            ? InternalChecklist.fromJS(state.cancelled)
            : state.cancelled;
        state.completed = state.completed
            ? InternalChecklist.fromJS(state.completed)
            : state.completed;
        state.started = state.started
            ? InternalChecklist.fromJS(state.started)
            : state.started;
        state.arrived = state.arrived
            ? InternalChecklist.fromJS(state.arrived)
            : state.arrived;
        state.transacting = state.transacting
            ? InternalChecklist.fromJS(state.transacting)
            : state.transacting;
        state.slaDelay = state.slaDelay
            ? InternalChecklist.fromJS(state.slaDelay)
            : state.slaDelay;
        return new this(Immutable.Map(state));
    }

    get cancelled(): ?InternalChecklist {
        return this._state.get('cancelled');
    }

    get completed(): ?InternalChecklist {
        return this._state.get('completed');
    }

    get started(): ?InternalChecklist {
        return this._state.get('started');
    }

    get arrived(): ?InternalChecklist {
        return this._state.get('arrived');
    }

    get transacting(): ?InternalChecklist {
        return this._state.get('transacting');
    }

    get slaDelay(): ?InternalChecklist {
        return this._state.get('slaDelay');
    }
}

class InternalSelectedChecklist extends SelectedChecklist {
    static fromJS(json: SelectedChecklistModelType): InternalSelectedChecklist {
        const state: Object = Object.assign({}, json);
        state.items = Immutable.List(state.items).map(item =>
            SelectedChecklistItem.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    get items(): Immutable.List<SelectedChecklistItem> {
        return this._state.get('items');
    }
}

class InternalSelectedChecklists extends SelectedChecklists {
    static fromJS(
        json: SelectedChecklistsModelType
    ): InternalSelectedChecklists {
        const state: Object = Object.assign({}, json);
        state.cancelled = state.cancelled
            ? InternalSelectedChecklist.fromJS(state.cancelled)
            : state.cancelled;
        state.completed = state.completed
            ? InternalSelectedChecklist.fromJS(state.completed)
            : state.completed;
        state.started = state.started
            ? InternalSelectedChecklist.fromJS(state.started)
            : state.started;
        state.arrived = state.arrived
            ? InternalSelectedChecklist.fromJS(state.arrived)
            : state.arrived;
        state.transacting = state.transacting
            ? InternalSelectedChecklist.fromJS(state.transacting)
            : state.transacting;
        state.slaDelay = state.slaDelay
            ? InternalSelectedChecklist.fromJS(state.slaDelay)
            : state.slaDelay;
        return new this(Immutable.Map(state));
    }

    get cancelled(): ?InternalSelectedChecklist {
        return this._state.get('cancelled');
    }

    get completed(): ?InternalSelectedChecklist {
        return this._state.get('completed');
    }

    get started(): ?InternalSelectedChecklist {
        return this._state.get('started');
    }

    get arrived(): ?InternalSelectedChecklist {
        return this._state.get('arrived');
    }

    get transacting(): ?InternalSelectedChecklist {
        return this._state.get('transacting');
    }

    get slaDelay(): ?InternalSelectedChecklist {
        return this._state.get('slaDelay');
    }
}

export {
    InternalChecklist as Checklist,
    InternalTaskChecklists as TaskChecklists,
    InternalSelectedChecklist as SelectedChecklist,
    InternalSelectedChecklists as SelectedChecklists
};
